import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_download",
  "use": "micro_download-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_download\"><path d=\"M4.5 0a.5.5 0 0 1 .5.5v7.792l3.146-3.146.07-.057a.5.5 0 0 1 .695.695l-.057.07-4 4-.042.037-.062.042-.094.042-.067.017L4.5 10l-.053-.003-.074-.013-.081-.03-.076-.043-.057-.046L.146 5.854a.5.5 0 0 1 .638-.765l.07.057L4 8.293V.5a.5.5 0 0 1 .5-.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol